import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../services/session.service';

@Component({
    selector: 'app-logout',
    standalone: true,
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit {
    constructor(private readonly sessionService: SessionService) { }

    ngOnInit(): void {
        this.sessionService.signOut().subscribe();
    }
}
